import ApplicationModel, { attr } from '../ApplicationModel';
import { type BusinessModelAttributes } from './generated/BusinessModelAttributes';
import { model } from '../modelBuilder';

interface BusinessModel extends BusinessModelAttributes {}

@model
class BusinessModel extends ApplicationModel {
  // Start auto-generated
  static typename: 'BusinessModel' = 'BusinessModel';
  get typename(): 'BusinessModel' {
    return 'BusinessModel';
  }

  static internalTypename: 'BusinessModel' = 'BusinessModel';
  get internalTypename(): 'BusinessModel' {
    return 'BusinessModel';
  }

  static fields = {
    commentsCount: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    path: attr({ readable: true }),
    referenceNum: attr({ readable: true }),
    type: attr({ readable: true }),
    description: attr.belongsTo({ readable: true, typename: 'Note' }),
    comments: attr.hasMany({ readable: true }),
    tasks: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default BusinessModel;
